
































import Vue from 'vue';
import DocumentParagraphComparison from './DocumentParagraphComparison/DocumentParagraphComparison.vue';
import DocumentRepoInfo from './DocumentRepoInfo/DocumentRepoInfo.vue';
import DocumentRepoChart from './DocumentRepoChart/DocumentRepoChart.vue';

export default Vue.extend({
  name: 'DocumentRepoView',
  components: {
    DocumentRepoInfo,
    DocumentRepoChart,
    DocumentParagraphComparison,
  },
});
